<template>
  <card style="height: calc(100% - 20px)" class="doctor-details-card">
    <doctor-details :doctor="doctor" :hideBillingDetails="hideBillingDetails"></doctor-details>

    <template v-slot:footer>
      <slot name="footer"></slot>
    </template>
  </card>
</template>

<script>
export default {
  name: "DoctorDetailsCard",

  props: ["doctor", "hideBillingDetails"],
};
</script>

<style scoped>
/deep/ hr {
  display: none;
}
</style>
